const BASE_PATH = "VENDOR";
export const SET_VENDOR_AVATAR = `${BASE_PATH}/SET_VENDOR_AVATAR`;

export const setAvatar = avatar => ({
    type: SET_VENDOR_AVATAR,
    avatar
});

const initialState = {
    avatar: ""
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_VENDOR_AVATAR:
            return { ...state, avatar: action.avatar };
    }

    return state;
}